/* jshint esnext: true */

const inputWidth = document.getElementById( 'width' );
const inputHeight = document.getElementById( 'height' );
const inputSeed = document.getElementById( 'seed' );
const inputTileset = document.getElementById( 'tileset' );
const buttonRandomSeed = document.getElementById( 'randomseed' );

/**
 *
 */
const settings = {

	// Size of each maze tile.
	tileWidth: 16,
	tileHeight: 16,

	// Size of the map in number of tiles wide.
	width: 16,

	// Size of the map in number of tiles high.
	height: 18,

	tileset: 1,

	// Random seed.
	seed: rando.range( 10000, 99999 ),

	// Amount of space taken up by land.
	islandArea: 0.3,

	// Starting position.
	x: null,
	y: null,


	/**
	 * Initialize the settings.
	 */
	init: function( width, height, seed, tileset ) {

		if ( !width ) {
			width = 16;
		}

		if ( !height ) {
			height = 18;
		}

		if ( !tileset ) {
			tileset = 1;
		}

		if ( !seed ) {
			seed = 0;
		}

		// Set map properties.
		this.width = width;
		this.height = height;
		this.tileset = tileset;
		this.seed = seed;

		this.display();

		rando.seed = this.seed;

	},


	/**
	 * Initialize the settings toggle so that we can turn on and off the editor.
	 */
	initToggle: function() {

		document.querySelector( '.open-settings' ).addEventListener(
			'click',
			function( e ) {

				e.preventDefault();

				document.querySelector( 'body' ).classList.toggle( 'display-settings' );

			}
		);

	},


	/**
	 * Set a random tileset.
	 */
	randomTileset: function() {

		let newTileset = rando.range( 1, Object.keys( tilesets ).length );
		console.log( 'newTileset', newTileset );

		this.tileset = newTileset;
		this.display();

	},


	/**
	 * Update the display inputs to match the settings values.
	 */
	display: function() {

		inputWidth.value = this.width;
		inputHeight.value = this.height;
		inputSeed.value = this.seed;
		inputTileset.value = this.tileset;

	},


	/**
	 * Check the input values to see if they need to be updated.
	 */
	check: function() {

		if (
			inputWidth.value != this.width ||
			inputHeight.value != this.height ||
			inputSeed.value != this.seed ||
			inputTileset.options[ inputTileset.selectedIndex ].value != this.tileset
		) {

			this.update();

		}

	},


	/**
	 * Update the settings.
	 */
	update: function() {

		this.width = parseInt( inputWidth.value );
		this.height = parseInt( inputHeight.value );
		this.tileset = parseInt( inputTileset.options[ inputTileset.selectedIndex ].value );
		this.seed = parseInt( inputSeed.value );
		rando.seed = this.seed;

		map.init();
		map.generate();

	}

};